
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-slot:activator="{ props }">
      <v-btn color="primary" :class="{'float-right': floatRight}" v-bind="props"
        ><v-icon class="mr-2">mdi-plus</v-icon> Novo Usuário</v-btn
      >
    </template>
      <v-card>
        <v-toolbar color="primary" :title="editUser?.id ? `[${editUser.email}] - ${editUser.name} (editar usuario)` : 'Novo usuário'">
          <v-btn color="black" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <FormUser :user="user" :editUser="editUser" :legalPersonId="legalPersonId" @updated="createdObject"/>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" color="error" @click="dialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>
<script>
import FormUser from './FormUser.vue';
export default {
  components: { FormUser },
  props: {
    user: Object,
    floatRight: Boolean,
    editUser: Object,
    dialogStatus: Boolean,
    legalPersonId: Number,
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {},
  activated() {},
  methods: {
    createdObject(object) {
      this.$emit('updated', object)
    }
  },
  computed: {},
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.$emit('closed')
      }
    },
    dialogStatus(newVal) {
      if (newVal) {
        this.dialog = true
      }
    }
  }
};
</script>
